import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { CACHE_PROVINCE } from "src/constants/actionCache";
import useCurrentActionCache from "src/hooks/useCurrentActionCache";
import {
  createProvince,
  getListProvince,
  removeProvince,
  updateProvince,
} from "src/apis/ADB/province.api";
import ProvinceControlPanel from "../controlPanel/ProvinceControlPanel";
import { getListDistrict } from "src/apis/ADB/district.api";
import { NotifyConfirm, Toast } from "src/components/notify/Notify";
import ProvinceTable from "../Table/ProvinceTable";
import { dataStateType } from "src/constants/status";
import { defaultProvince } from "../../utils";
import Controls from "src/components/form/controls/Controls";

const Provinces = ({ provinceId = defaultProvince.id, setProvinceId }) => {
  const { currentActionCache, setCurrentActionCache } = useCurrentActionCache();

  const [openPopup, setOpenPopup] = useState(false);
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [listProvince, setListProvince] = useState([defaultProvince]);

  useEffect(() => {
    getListProvince((result) => {
      setListProvince([defaultProvince, ...result]);
    });
  }, []);

  const actionAfterUpsert = (result, resetForm) => {
    getListProvince((result) => {
      setListProvince([defaultProvince, ...result]);
      setCurrentActionCache(CACHE_PROVINCE);
      resetForm();
    });
  };

  const addOrEdit = (province, resetForm) => {
    if (province.id) {
      updateProvince(province.id, province, (result) => {
        actionAfterUpsert(result, resetForm);
      });
    } else {
      createProvince(province, (result) => {
        actionAfterUpsert(result, resetForm);
      });
    }
  };

  const handleDelete = (province) => {
    getListDistrict({ provinceId: province.id }, (result) => {
      if (result.length) {
        Toast("warning", "Tỉnh/Thành vẫn còn Quận/Huyện, không thể xóa");
      } else {
        NotifyConfirm("warning", "Are you delete it ?", (result) => {
          if (result.isConfirmed) {
            removeProvince(province.id, (result) => {
              getListProvince((result) => {
                setProvinceId(defaultProvince.id);
                setListProvince([defaultProvince, ...result]);
                setCurrentActionCache(CACHE_PROVINCE);
              });
            });
          }
        });
      }
    });
  };

  const handleOnChange = (e) => {
    const { value } = e.target;
    setProvinceId(value);
  };

  const handleOpenPopup = (isOpen, item) => {
    setOpenPopup(isOpen);
    setRecordForEdit(item);
  };

  return (
    <div style={{ width: "100%", margin: "0 10px" }}>
      <Controls.AdministrativeSelect
        name="province"
        label="Province"
        value={provinceId}
        onChange={handleOnChange}
        options={listProvince}
        optionField={{ key: "id", value: "provinceName" }}
      />

      <ProvinceControlPanel
        currentActionCache={currentActionCache}
        openPopup={openPopup}
        setOpenPopup={setOpenPopup}
        recordForEdit={recordForEdit}
        addOrEdit={addOrEdit}
        handleOpenPopup={handleOpenPopup}
      />

      <ProvinceTable
        provinceId={provinceId}
        data={listProvince}
        handleDelete={handleDelete}
        handleOpenPopup={handleOpenPopup}
        status={dataStateType.ACTIVE}
      />
    </div>
  );
};

export default Provinces;
